import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import CreateRepository from "../Repositories/CreateRepository";

class CreateBloc {
  createChannel = new Subject();
  detailChannel = new Subject();
  repository = new CreateRepository();

  constructor() {
    this.createChannel.next({ status: apiResponse.INITIAL });
    this.detailChannel.next({ status: apiResponse.INITIAL });
  }

  fetchCreate = async (query) => {
    try {
      this.createChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchCreate(query)
        .then((result) => {
          this.createChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.createChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", error);
    }
  };

  fetchDetail = async (query) => {
    try {
      this.detailChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDetail(query)
        .then((result) => {
          this.detailChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", error);
    }
  };
}

export default CreateBloc;
